export const extractAssignmentsState = (records) => {
  return (records || [])
    .filter(({ name }) => name === 'participantStateChanged') // leave only participantStateChanged messages
    .sort((a, b) => b.timestamp - a.timestamp) // most recent first
    .reduce((acc, message) => {
      const { data, timestamp } = message || {};
      const { status, participants } = data || {};

      if (!status) return acc;

      if (!acc[status]) {
        const filteredParticipants = participants.filter((p) => {
          const allParticipants = new Set(
            Object.values(acc).flatMap((a) =>
              a.participants.map((ap) => ap.identity)
            )
          );
          return !allParticipants.has(p.identity);
        });

        acc[status] = {
          timestamp,
          ...data,
          participants: filteredParticipants,
        };
      }

      return acc;
    }, {});
};
